import { connect } from 'react-redux';
import { GET_VOUCHER_LIST } from 'store/voucher/actionTypes';
import { actionDeleteVoucherCampaign } from 'store/voucher/actions';
import ManagerVoucher from './ManagerVoucher';

const mapStateToProps = (state) => ({
  isLoadingGetVoucherList: state.Voucher.isLoadingGetVoucherList,
  isLoadingDeleteVoucherCampaign: state.Voucher.isLoadingDeleteVoucherCampaign,
  voucherList: state.Voucher.voucherList,
  voucherTotal: state.Voucher.voucherTotal,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetListVoucher: (payload) =>
    dispatch({
      type: GET_VOUCHER_LIST,
      payload,
    }),
  actionDeleteVoucherCampaign: (payload) =>
    dispatch(actionDeleteVoucherCampaign(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ManagerVoucher);
